<template>
  <v-dialog v-model="dialog" width="800" persistent>
    <v-card>
      <v-alert v-model="alertFlg" type="error" density="compact" :title=errorMsg closable class="ma-2" />

      <v-card-text class="pa-4 pre-line grey--text text--darken-4 text-subtitle-1 px-5">
        <p class="mb-4">
          {{ $t('receivingForcedRegisterDialog.message.confirm') }}
        </p>
        <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="staffCode"
          :label="$t('receivingForcedRegisterDialog.label.staffCode')" :counter="staffCodeMaxLength"
          :maxLength="staffCodeMaxLength" :disabled="isLoading" :rules="[rules.checkStaffCode]" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isLoading"> {{ $t('common.action.cancel') }} </v-btn>
        <v-btn color="indigo darken-1" dark @click="ok" :loading="isLoading" :disabled="invalidInput">
          {{ $t('common.action.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import api from "@/apis/staff";
import constant from "@/utils/constant"
import store from "@/store";

export default {
  props: {
    handleClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    invalidInput() {
      if (!this.isValidStaffCode(this.staffCode)) return true;
      return this.staffCode.length == 0 || this.staffCode.length > this.staffCodeMaxLength;
    },
  },
  data() {
    return {
      staffCode: "",
      isLoading: false,
      dialog: true,
      errorMsg: "",
      alertFlg: false,
      staffCodeMaxLength: 0,
      rules: {
        checkStaffCode: v => {
          return this.isValidStaffCode(v) || this.$t('receivingForcedRegisterDialog.validation.halfAlnum');
        },
      },
    };
  },
  methods: {
    isValidStaffCode(v) {
      return /^[0-9A-Za-z]*$/.test(v);
    },
    async ok() {
      try {
        this.isLoading = true;
        this.alertFlg = false;

        const response = await api.post("/nyuka/actual/forced-register", {
          denpyoNumber: store.getNyukaDenpyoNumber(),
          staffId: this.staffCode,
        });

        if (response.data?.status != 0) throw "";
        this.handleClose(true);
      } catch (e) {
        // NOTE 予定から実績を作っているので、基本エラーにならなし、エラーになる場合は整合性エラーでユーザー側で対応ができない。
        // 汎用的なエラーメッセージを表示して再検索を促す
        this.errorMsg = this.$t('common.message.errorAndRetry');
        this.alertFlg = true;
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      if (this.isLoading) return;
      this.handleClose(false);
    },
  },
  mounted() {
    this.staffCodeMaxLength = constant.STAFF_CODE_MAX_LENGTH;
  },
};
</script>
<style>
.pre-line {
  white-space: pre-line;
}
</style>
